import reducer from "./reducer";
export { default as Specializations } from "./components/index";
export { default as specializationsReducerName } from "./constants";
export default reducer;
